<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body mb-0">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-0">
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                  [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                  [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-0">
                  <div class="row-flex">
                    <div class="col-flex-2 position-relative">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" (keydown.enter)="filter(searchVal)" placeholder="Search" #name
                        [(ngModel)]="searchVal" />
                      <button class="btn search-btn glow position-absolute" (click)="filter(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2">
                      <button class="btn btn-primary btn-block users-list-clear glow" (click)="resetFilter()">Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="reset" class="btn btn-primary btn-block users-list-clear glow"
                      routerLink="/contact/add" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>
                  </div>
                  <!-- <div class="row-flex">
                    <div class="col-flex-2 mb-1">
                      <label for="ngx-filter-ref">Search:
                        <input id="ngx-filter-ref" class="form-control form-control-sm d-inline-block width-200 ml-1"
                          type="text" (keyup)="getContactFilter($event)" />
                      </label>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/contact/add">
                        Add
                      </button>
                    </div>
                  </div> -->
                </div>
              </div>
            </fieldset>
            <div class="col mt-0 mb-1">
              <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Contacts Guideline</button>
            </div>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
              (page)="pageChangeData($event)">
              <ngx-datatable-column name="Name" prop="name" [width]="50">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center">
                    <div class="cell-line-height cursor-pointer" (click)="openModal(myModal,row)">
                      <p class="font-medium-1 line-height-1 mb-0">
                        {{ row.name }}
                      </p>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Email" prop="email" [width]="70"></ngx-datatable-column>
              <ngx-datatable-column name="Phone" prop="phone" [width]="70"></ngx-datatable-column>
              <ngx-datatable-column name="Type" prop="type_client" [width]="70">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row?.type_client[0]?.displayname}}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Actions" [width]="50"
                *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <i class="ft-edit text-primary cursor-pointer mx-1" (click)="editContact(row)"></i>
                  <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger mx-1"
                    (click)="Delete(row._id)"></i>
                  <i *ngIf="!row?.user[0]?._id" class="ft-settings text-primary cursor-pointer mx-1" (click)="updateContactRole(row?._id)" placement="right" ngbTooltip="update role guest" ></i>
                  
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>
<!-------------- References  Popup ------------------------------------------->
<div>
  <ng-template #myModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{row_data?.name}}'s References & Notes</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
     <div>
      <div *ngIf="row_data?.refrences">
        <label>Refrences</label>
        <p [innerHTML]="row_data?.refrences"></p>
      </div>
      <div *ngIf="!row_data?.refrences">
        Data not found!
      </div>
     </div>
     <div>
      <div *ngIf="row_data?.notes">
        <label>Notes</label>
        <p [innerHTML]="row_data?.notes"></p>
      </div>
      <div *ngIf="!row_data?.notes">
        Data not found!
      </div>
     </div>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      </div>
  </ng-template>
</div>

 
<!------------- Referral Popup --------------------------------------->
<div>
	<ng-template #myModalContent>
	  <div class="modal-header">
		<h4 class="modal-title">{{row_name}}'s Referral</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
      <fieldset class="form-group" >
				<label>Report To</label>
				<ng-select
				[items]="emp_list"
				bindLabel="name"
				bindValue="user._id"
				[closeOnSelect]="false"
				placeholder="Select"
				[(ngModel)]="referral_model.report_to"
				[ngModelOptions]="{ standalone: true }"
				(change)="getEmpId($event)"
			  ></ng-select>
			  </fieldset>
			  <fieldset class="form-group">
          <label>Notes</label>
          <textarea
          [(ngModel)]="referral_model.notes"
            id="hidden-label-form-6"
            rows="3"
            class="form-control"
            name="notes"
            placeholder="Enter notes"
          ></textarea>
        </fieldset>
        <fieldset class="form-group">
          <label>Admin Notes</label>
          <textarea
          [(ngModel)]="referral_model.admin_notes"
            id="hidden-label-form-6"
            rows="3"
            class="form-control"
            name="admin_notes"
            placeholder="Enter admin notes"
          ></textarea>
        </fieldset>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="addReferral()">Submit</button>
	  </div>
	</ng-template>
</div>